import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-properties-form-validation-message',
  templateUrl: './properties-form-validation-message.component.html',
  styleUrls: ['./properties-form-validation-message.component.scss']
})
export class PropertiesFormValidationMessageComponent {
  @Input() inputData: any;
  @Input() control: any;
  constructor(
  ) { }
}
